import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { API } from '../api/config';

export default function useUserReservations() {
    const { user, logout } = useContext(AuthContext);
    const [reservations, setReservations] = useState([]);
    const [loadingReservations, setLoadingReservations] = useState(true);
    const [errorReservations, setErrorReservations] = useState(null);

    useEffect(() => {
        if (!user?.token) {
            setLoadingReservations(false);
            return;
        }

        let isMounted = true;

        const fetchReservations = async () => {
            setLoadingReservations(true);
            setErrorReservations(null);

            try {
                const response = await fetch(`${API.RESERVAS}/minhasreservas`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ googleToken: user.token })
                });

                if (response.status === 401) {
                    logout();
                    return;
                }

                if (!response.ok) {
                    throw new Error("Falha ao buscar reservas da API");
                }

                const data = await response.json();

                let rawReservations = [];
                if (Array.isArray(data)) {
                    rawReservations = data;
                } else if (data && Array.isArray(data.reservas)) {
                    rawReservations = data.reservas;
                } else if (data && Array.isArray(data.reservations)) {
                    rawReservations = data.reservations;
                }

                const normalizedReservations = rawReservations.map(res => ({
                    ...res,
                    id:           res.ID || res.id,
                    date:         res.Data || res.date || "Data não informada",
                    time:         res.Time || res.time,
                    type:         res.Type || res.type,
                    status:       res.Status || res.status,
                    participants: res.Participants || []
                }));

                if (isMounted) setReservations(normalizedReservations);

            } catch (err) {
                console.error("Erro no fetch de reservas:", err);
                if (isMounted) setErrorReservations("Não foi possível carregar suas reservas.");
            } finally {
                if (isMounted) setLoadingReservations(false);
            }
        };

        fetchReservations();
        return () => { isMounted = false; };

    }, [user, logout]);

    return { reservations, loadingReservations, errorReservations };
}